/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExportAodRunsQueryResponse, AuditReportsExportAodRunsQueryParams, AuditReportsExportAodRuns401, AuditReportsExportAodRuns403 } from "../models/AuditReportsExportAodRuns";

export function getAuditReportsExportAodRunsUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-runs/export` as const }
  return res
}

/**
 * @summary Export AOD runs (csv, xls, json)
 * {@link /audit-reports/v1/aod-runs/export}
 */
export async function auditReportsExportAodRuns(params: AuditReportsExportAodRunsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsExportAodRunsQueryResponse, ResponseErrorConfig<AuditReportsExportAodRuns401 | AuditReportsExportAodRuns403>, unknown>({ method : "GET", url : getAuditReportsExportAodRunsUrl().url.toString(), params, ... requestConfig })
  return res.data
}